module.exports = __webpack_public_path__ + "img/VAT.818414c0.svg";